// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dyAc","content":"styles_content__2FYf3"};